<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="people-fill"></b-icon>
            <div class="mLeft">Alta precios</div>
          </div>
          <div class="alignIcon bold">CÓDIGO: RQ_03</div>
        </div>

        <div class="noAlTope">
          <b-form v-on:submit.prevent="validarEnvio">
            <b-container class="mb-4">
              <b-form-file
                :state="archivo.length != 0"
                accept=".csv"
                v-on:change="cargarCsv"
                required
              >
              </b-form-file>
              <b-form-invalid-feedback
                class="text-left"
                :state="archivo.length != 0"
              >
                Debe seleccionar un archivo .csv
              </b-form-invalid-feedback>
            </b-container>

            <b-button variant="primary" v-if="enviando" disabled>
              <b-spinner small></b-spinner>
              Cargando...
            </b-button>
            <b-button type="submit" variant="outline-primary" v-else>
              Guardar
            </b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";

export default {
  name: "AltaPrecio",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    archivo: [],
    enviando: false,
  }),
  methods: {
    cargarCsv(evt) {
      var supper = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(evt.target.files[0]);

        reader.onload = function (event) {
          supper.archivo = supper.csvJson(event.target.result);
        };
      } else {
        this.$swal({
          icon: "error",
          text: "FileReader no es soportado en este navegador.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      }
    },
    csvJson(csv) {
      let lineas = csv.split("\n");
      let resultado = [];

      lineas.forEach((element) => {
        let lista = element.split(",");
        resultado.push({
          keplerKey: lista[0],
          precio: parseFloat(lista[1]),
        });
      });

      // removemos el ultimo registro por que es undefined;
      resultado.pop();
      return resultado;
    },
    validarEnvio() {
      if (this.archivo.length !== 0) {
        this.$swal({
          title: "¿El archivo es correcto?",
          icon: "question",
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Guardar",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.enviando = true;
            this.enviarArchivo();
          }
        });
      }
    },
    enviarArchivo() {
      const url = this.$api + "requisiciones/precios";

      this.$http
        .post(url, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.errorEnvio(err);
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    traerDatos() {
      return {
        listaPrecios: this.archivo,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };
    },
  },
  notifications: {
    errorEnvio: {
      type: "error",
      title: "Error",
      message: "Error al enviar la información",
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style>
</style>